const YT_PATTERN =
  /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([^&?/\s]{11})/;

export function getYouTubeId(url) {
  if (!url) return null;
  const match = url.match(YT_PATTERN);
  return match ? match[1] : null;
}

export function isYouTubeUrl(url) {
  return !!getYouTubeId(url);
}

// Devuelve la URL de embed lista para usar en un <iframe>
export function getYouTubeEmbedUrl(url, autoplay = false) {
  const id = getYouTubeId(url);
  if (!id) return url;
  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
    controls: '1',
    ...(autoplay ? { autoplay: '1' } : {}),
  });
  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}

// Thumbnail de mayor calidad disponible
export function getYouTubeThumbnail(id) {
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}
